import { render, staticRenderFns } from "./all_manuscripts.vue?vue&type=template&id=55f5f42b&scoped=true&"
import script from "./all_manuscripts.vue?vue&type=script&lang=js&"
export * from "./all_manuscripts.vue?vue&type=script&lang=js&"
import style0 from "./all_manuscripts.vue?vue&type=style&index=0&id=55f5f42b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5f42b",
  null
  
)

export default component.exports